import { BaseRequest, IBaseRequest } from "../../BaseRequest";

export interface IGetContactRequest extends IBaseRequest {
    id?:number;
    organizationId?:number;
    contactId?:number;
    folder?:number;
    quickView?:boolean;
    oldId?:string;
    sysUser?:number;
    externalSystem?:string;
    externalId?:string;
}

export class GetContactRequest extends BaseRequest implements IGetContactRequest {
    public id?:number;
    public organizationId?:number;
    public contactId?:number;
    public folder?:number;
    public quickView?:boolean;
    public oldId?:string;
    public sysUser?:number;
    public externalSystem?:string;
    public externalId?:string;

    constructor(_server:string, _sessionId:string,
        _id?:number,
        _organizationId?:number,
        _contactId?:number,
        _folder?:number,
        _quickView?:boolean,
        _oldId?:string,
        _sysUser?:number,
        _externalSystem?:string,
        _externalId?:string,
        ) {

        super(_server, _sessionId);
        this.id = _id;
        this.organizationId = _organizationId;
        this.contactId = _contactId;
        this.folder = _folder;
        this.quickView = _quickView;
        this.oldId = _oldId;
        this.sysUser = _sysUser;
        this.externalSystem = _externalSystem;
        this.externalId = _externalId;
    }

    toXml(): string {
        var parameters:string = super.toXml();
        parameters += this.makeNode(this.id, 'id');
        parameters += this.makeNode(this.organizationId, 'organizationId');
        parameters += this.makeNode(this.contactId, 'contactId');
        parameters += this.makeNode(this.folder, 'folder');
        parameters += this.makeNode(this.quickView, 'quickView');
        parameters += this.makeNode(this.oldId, 'oldId');
        parameters += this.makeNode(this.sysUser, 'sysUser');
        parameters += this.makeNode(this.externalSystem, 'externalSystem');
        parameters += this.makeNode(this.externalId, 'externalId');

        return super.wrapperXml("GetContact", parameters);
    }
}